import React from "react";
import { Link } from "react-router-dom";
import "./AppHeader.css";

function AppHeader() {
  return (
    <header className="flex-column flex-all-center header px-8">
      <Link to="/">
        <img className="bi" src="./bi.png" alt="캡틴판교 x 인프런" />
      </Link>
      <h2 className="pb-2 text-large">
        캡틴판교 인프런 강의 <span className="key-content">학생 할인</span> 받기
      </h2>
      <p className="font-gray-bold">
        개인 정보는 인증 목적으로만 활용되며 학생증은 서버에 저장하지 않습니다.
        수입이 없는 학생분들께 더 많은 혜택이 돌아갈 수 있도록 학생분들께 양보
        부탁드립니다 :)
      </p>
    </header>
  );
}

export default AppHeader;
